export const SUPPLIER_DEALS_CONTAINER_DIV: React.CSSProperties = {
  marginTop: '8px',
}
